import { render, staticRenderFns } from "./CourseCardSmall.vue?vue&type=template&id=a7122b98&scoped=true&"
import script from "./CourseCardSmall.vue?vue&type=script&lang=ts&"
export * from "./CourseCardSmall.vue?vue&type=script&lang=ts&"
import style0 from "./CourseCardSmall.vue?vue&type=style&index=0&id=a7122b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7122b98",
  null
  
)

export default component.exports